import { render, staticRenderFns } from "./BusinessUnitCard.vue?vue&type=template&id=12f41bd0&scoped=true&"
import script from "./BusinessUnitCard.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitCard.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUnitCard.vue?vue&type=style&index=0&id=12f41bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f41bd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCardText,VRow,VSelect})
